import * as types from "./mutation_types";

export default {
  [types.STRUCTURE_ROB_RESET](state) {
    Object.assign(state, {
      error: "",
      isLoading: false,
      items: null,
      previous: null,
      next: null,
    });
  },

  [types.STRUCTURE_ROB_SET_ERROR](state, error) {
    Object.assign(state, { error });
  },

  [types.STRUCTURE_ROB_SET_ITEMS](state, items) {
    Object.assign(state, { items });
  },

  [types.STRUCTURE_ROB_TOGGLE_LOADING](state) {
    Object.assign(state, { isLoading: !state.isLoading });
  },
};
